import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "../badRequestHandler/BadRequestHandler";

export const SignatureApi = createApi({
  reducerPath: "signatureApi",
  baseQuery: dynamicBaseQuery,
  refetchOnMountOrArgChange: true,

  endpoints: (builder) => ({
    getSignature: builder.query({
      query: ({ selectedTeam }) => ({
        url: `v1/common/email-signatures/?team=${selectedTeam}`,
        method: "GET",
      }),
    }),
    createSign: builder.mutation({
      query: (body) => ({
        url: `v1/common/email-signatures/`,
        method: "POST",
        body,
      }),
    }),

    updateSign: builder.mutation({
      query: ({ body, id }) => ({
        url: `v1/common/email-signatures/${id}/`,
        method: "PATCH",
        body,
      }),
    }),

    deleteSign: builder.mutation({
      query: ({ body, id }) => ({
        url: `v1/common/email-signatures/${id}/`,
        method: "DELETE",
        body,
      }),
    }),

    SignatureInEmail: builder.query({
      query: ({ user_id }) => ({
        url: `v1/emails/threads/fetch-signature/?user=${user_id}`,
        method: "GET",
      }),
    }),

    smtpMailConfigsSignature: builder.query({
      query: (selectedTeam) => {
        return {
          url: `v1/common/smtp-server-configuration/team-config/${selectedTeam}/`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useGetSignatureQuery,
  useCreateSignMutation,
  useUpdateSignMutation,
  useDeleteSignMutation,
  useSignatureInEmailQuery,
  useSmtpMailConfigsSignatureQuery,
} = SignatureApi;
